import { PreviewVariant } from '../../preview-common/preview-variant.interface';
import { PmaxGoogleSearchMobile01PreviewComponent } from './google-search-mobile-01/google-search-mobile-01.component';
import { PmaxGoogleSearchMobile02PreviewComponent } from './google-search-mobile-02/google-search-mobile-02.component';
import { PmaxGoogleSearchMobile03PreviewComponent } from './google-search-mobile-03/google-search-mobile-03.component';
import { PmaxGoogleSearchMobile04PreviewComponent } from './google-search-mobile-04/google-search-mobile-04.component';
import { PmaxGoogleSearchDesktop01PreviewComponent } from './google-search-desktop-01/google-search-desktop-01.component';
import { PmaxGoogleSearchDesktop02PreviewComponent } from './google-search-desktop-02/google-search-desktop-02.component';
import { PmaxGoogleSearchDesktop03PreviewComponent } from './google-search-desktop-03/google-search-desktop-03.component';
import { PmaxDisplayMobile01PreviewComponent } from './display-mobile-01/display-mobile-01.component';
import { PmaxDisplayMobile02PreviewComponent } from './display-mobile-02/display-mobile-02.component';
import { PmaxDisplayMobile03PreviewComponent } from './display-mobile-03/display-mobile-03.component';
import { PmaxDisplayMobile04PreviewComponent } from './display-mobile-04/display-mobile-04.component';
import { PmaxDisplayMobile05PreviewComponent } from './display-mobile-05/display-mobile-05.component';
import { PmaxDisplayDesktop01PreviewComponent } from './display-desktop-01/display-desktop-01.component';
import { PmaxDisplayDesktop02PreviewComponent } from './display-desktop-02/display-desktop-02.component';
import { PmaxDisplayDesktop03PreviewComponent } from './display-desktop-03/display-desktop-03.component';
import { PmaxYoutubeMobile01PreviewComponent } from './youtube-mobile-01/youtube-mobile-01.component';
import { PmaxYoutubeMobile01SquarePreviewComponent } from './youtube-mobile-01-square/youtube-mobile-01-square.component';
import { PmaxYoutubeMobile01PortraitPreviewComponent } from './youtube-mobile-01-portrait/youtube-mobile-01-portrait.component';
import { PmaxYoutubeMobile02PreviewComponent } from './youtube-mobile-02/youtube-mobile-02.component';
import { PmaxYoutubeMobile03PreviewComponent } from './youtube-mobile-03/youtube-mobile-03.component';
import { PmaxYoutubeMobile04PreviewComponent } from './youtube-mobile-04/youtube-mobile-04.component';
import { PmaxYoutubeMobile05PreviewComponent } from './youtube-mobile-05/youtube-mobile-05.component';
import { PmaxYoutubeMobile06PreviewComponent } from './youtube-mobile-06/youtube-mobile-06.component';
import { PmaxYoutubeDesktop01PreviewComponent } from './youtube-desktop-01/youtube-desktop-01.component';
import { PmaxYoutubeDesktop02PreviewComponent } from './youtube-desktop-02/youtube-desktop-02.component';
import { PmaxYoutubeDesktop03PreviewComponent } from './youtube-desktop-03/youtube-desktop-03.component';
import { PmaxDiscoverLandscapeMobilePreviewComponent } from './discover-landscape-mobile/discover-landscape-mobile.component';
import { PmaxDiscoverSquareMobilePreviewComponent } from './discover-square-mobile/discover-square-mobile.component';
import { PmaxGmailClosedOpen01MobilePreviewComponent } from './gmail-closed-open-01-mobile/gmail-closed-open-01-mobile.component';
import { PmaxGmailClosedOpen01DesktopPreviewComponent } from './gmail-closed-open-01-desktop/gmail-closed-open-01-desktop.component';
import { PmaxGmailMobile02PreviewComponent } from './gmail-mobile-02/gmail-mobile-02.component';
import { PmaxGmailDesktop02PreviewComponent } from './gmail-desktop-02/gmail-desktop-02.component';
import { PmaxGmailClosedOpen03MobilePreviewComponent } from './gmail-closed-open-03-mobile/gmail-closed-open-03-mobile.component';
import { PmaxGmailMobile04PreviewComponent } from './gmail-mobile-04/gmail-mobile-04.component';
import { PmaxVariablesTablePreviewComponent } from './variables-table/variables-table.component';

/**
 * The single source of truth for Performance Max preview variants. Add a
 * preview by creating a variant component and appending one entry here.
 */
export const PMAX_VARIANTS: PreviewVariant[] = [
  {
    id: 'google-mobile-01',
    platform: 'google',
    device: 'mobile',
    label: 'Google Search 01',
    component: PmaxGoogleSearchMobile01PreviewComponent,
  },
  {
    id: 'google-mobile-02',
    platform: 'google',
    device: 'mobile',
    label: 'Google Search 02',
    component: PmaxGoogleSearchMobile02PreviewComponent,
  },
  {
    id: 'google-mobile-03',
    platform: 'google',
    device: 'mobile',
    label: 'Google Search 03',
    component: PmaxGoogleSearchMobile03PreviewComponent,
  },
  {
    id: 'google-mobile-04',
    platform: 'google',
    device: 'mobile',
    label: 'Google Search 04',
    component: PmaxGoogleSearchMobile04PreviewComponent,
  },
  {
    id: 'google-desktop-01',
    platform: 'google',
    device: 'desktop',
    label: 'Google Search 01',
    component: PmaxGoogleSearchDesktop01PreviewComponent,
  },
  {
    id: 'google-desktop-02',
    platform: 'google',
    device: 'desktop',
    label: 'Google Search 02',
    component: PmaxGoogleSearchDesktop02PreviewComponent,
  },
  {
    id: 'google-desktop-03',
    platform: 'google',
    device: 'desktop',
    label: 'Google Search 03',
    component: PmaxGoogleSearchDesktop03PreviewComponent,
  },
  {
    id: 'display-mobile-01',
    platform: 'display',
    device: 'mobile',
    label: 'Display 01',
    component: PmaxDisplayMobile01PreviewComponent,
  },
  {
    id: 'display-mobile-02',
    platform: 'display',
    device: 'mobile',
    label: 'Display 02',
    component: PmaxDisplayMobile02PreviewComponent,
  },
  {
    id: 'display-mobile-03',
    platform: 'display',
    device: 'mobile',
    label: 'Display 03',
    component: PmaxDisplayMobile03PreviewComponent,
  },
  {
    id: 'display-mobile-04',
    platform: 'display',
    device: 'mobile',
    label: 'Display 04',
    component: PmaxDisplayMobile04PreviewComponent,
  },
  {
    id: 'display-mobile-05',
    platform: 'display',
    device: 'mobile',
    label: 'Display 05',
    component: PmaxDisplayMobile05PreviewComponent,
  },
  {
    id: 'display-desktop-01',
    platform: 'display',
    device: 'desktop',
    label: 'Display 01',
    component: PmaxDisplayDesktop01PreviewComponent,
  },
  {
    id: 'display-desktop-02',
    platform: 'display',
    device: 'desktop',
    label: 'Display 02',
    component: PmaxDisplayDesktop02PreviewComponent,
  },
  {
    id: 'display-desktop-03',
    platform: 'display',
    device: 'desktop',
    label: 'Display 03',
    component: PmaxDisplayDesktop03PreviewComponent,
  },
  {
    id: 'youtube-mobile-01',
    platform: 'youtube',
    device: 'mobile',
    label: 'YouTube 01 Landscape',
    component: PmaxYoutubeMobile01PreviewComponent,
  },
  {
    id: 'youtube-mobile-01-square',
    platform: 'youtube',
    device: 'mobile',
    label: 'YouTube 01 Square',
    component: PmaxYoutubeMobile01SquarePreviewComponent,
  },
  {
    id: 'youtube-mobile-01-portrait',
    platform: 'youtube',
    device: 'mobile',
    label: 'YouTube 01 Portrait',
    component: PmaxYoutubeMobile01PortraitPreviewComponent,
  },
  {
    id: 'youtube-mobile-02',
    platform: 'youtube',
    device: 'mobile',
    label: 'YouTube 02',
    component: PmaxYoutubeMobile02PreviewComponent,
  },
  {
    id: 'youtube-mobile-03',
    platform: 'youtube',
    device: 'mobile',
    label: 'YouTube 03',
    component: PmaxYoutubeMobile03PreviewComponent,
  },
  {
    id: 'youtube-mobile-04',
    platform: 'youtube',
    device: 'mobile',
    label: 'YouTube 04',
    component: PmaxYoutubeMobile04PreviewComponent,
  },
  {
    id: 'youtube-mobile-05',
    platform: 'youtube',
    device: 'mobile',
    label: 'YouTube 05',
    component: PmaxYoutubeMobile05PreviewComponent,
  },
  {
    id: 'youtube-mobile-06',
    platform: 'youtube',
    device: 'mobile',
    label: 'YouTube 06',
    component: PmaxYoutubeMobile06PreviewComponent,
  },
  {
    id: 'youtube-desktop-01',
    platform: 'youtube',
    device: 'desktop',
    label: 'YouTube 01',
    component: PmaxYoutubeDesktop01PreviewComponent,
  },
  {
    id: 'youtube-desktop-02',
    platform: 'youtube',
    device: 'desktop',
    label: 'YouTube 02',
    component: PmaxYoutubeDesktop02PreviewComponent,
  },
  {
    id: 'youtube-desktop-03',
    platform: 'youtube',
    device: 'desktop',
    label: 'YouTube 03',
    component: PmaxYoutubeDesktop03PreviewComponent,
  },
  {
    id: 'discover-landscape-mobile',
    platform: 'discover',
    device: 'mobile',
    label: 'Discover Landscape',
    component: PmaxDiscoverLandscapeMobilePreviewComponent,
  },
  {
    id: 'discover-square-mobile',
    platform: 'discover',
    device: 'mobile',
    label: 'Discover Square',
    component: PmaxDiscoverSquareMobilePreviewComponent,
  },
  {
    id: 'gmail-closed-open-01-mobile',
    platform: 'gmail',
    device: 'mobile',
    label: 'Gmail Closed/Open 01',
    component: PmaxGmailClosedOpen01MobilePreviewComponent,
  },
  {
    id: 'gmail-closed-open-01-desktop',
    platform: 'gmail',
    device: 'desktop',
    label: 'Gmail Closed/Open 01',
    component: PmaxGmailClosedOpen01DesktopPreviewComponent,
  },
  {
    id: 'gmail-mobile-02',
    platform: 'gmail',
    device: 'mobile',
    label: 'Gmail 02',
    component: PmaxGmailMobile02PreviewComponent,
  },
  {
    id: 'gmail-desktop-02',
    platform: 'gmail',
    device: 'desktop',
    label: 'Gmail 02',
    component: PmaxGmailDesktop02PreviewComponent,
  },
  {
    id: 'gmail-closed-open-03-mobile',
    platform: 'gmail',
    device: 'mobile',
    label: 'Gmail Closed/Open 03',
    component: PmaxGmailClosedOpen03MobilePreviewComponent,
  },
  {
    id: 'gmail-mobile-04',
    platform: 'gmail',
    device: 'mobile',
    label: 'Gmail 04',
    component: PmaxGmailMobile04PreviewComponent,
  },
  // ENABLE IF YOU WANT TO DEBUG
  // {
  //   id: 'variables-debug',
  //   platform: 'youtube',
  //   device: 'desktop',
  //   label: 'Variables (debug)',
  //   component: PmaxVariablesTablePreviewComponent,
  // },
];
